export const NOT_ALLOWED_BANKS = {
  ffb: 'Bitte beachten Sie, dass die Referenzbankverbindung nur mit einem entsprechenden ' +
    'Formular der Depotbank geändert werden kann und nicht innerhalb der Bestandskundenberatung. ' +
    'Bitte wählen Sie bei Bedarf das entsprechende Formular am Ende der Beratungsstrecke.'
}